var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUserTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5C7.64062 6.5 9 5.16406 9 3.5C9 1.85938 7.64062 0.5 6 0.5C4.33594 0.5 3 1.85938 3 3.5C3 5.16406 4.33594 6.5 6 6.5ZM6 1.25C7.21875 1.25 8.25 2.28125 8.25 3.5C8.25 4.74219 7.21875 5.75 6 5.75C4.75781 5.75 3.75 4.74219 3.75 3.5C3.75 2.28125 4.75781 1.25 6 1.25ZM8.13281 7.64844L7.21875 10.8594L6.42188 8.49219L7.00781 7.90625C7.24219 7.67188 7.07812 7.25 6.75 7.25H5.25C4.89844 7.25 4.73438 7.67188 4.96875 7.90625L5.55469 8.49219L4.75781 10.8594L3.84375 7.64844C2.10938 7.67188 0.75 9.05469 0.75 10.7891V11.375C0.75 12.0078 1.24219 12.5 1.875 12.5H10.125C10.7344 12.5 11.25 12.0078 11.25 11.375V10.7891C11.25 9.05469 9.86719 7.67188 8.13281 7.64844ZM1.875 11.75C1.66406 11.75 1.5 11.5859 1.5 11.375V10.7891C1.5 9.6875 2.25 8.72656 3.28125 8.46875L4.24219 11.75H1.875ZM5.25 11.75L6 9.57031L6.72656 11.75H5.25ZM10.5 11.375C10.5 11.5859 10.3125 11.75 10.125 11.75H7.73438L8.69531 8.46875C9.72656 8.72656 10.4766 9.6875 10.4766 10.7891V11.375H10.5Z",
    fill: "#486175",
    className: "fill-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUserTie);
export default __webpack_public_path__ + "static/media/ico-user-tie.a534e4dd59f7982490f8b480cd6b9872.svg";
export { ForwardRef as ReactComponent };